import React, { useCallback, useLayoutEffect, useMemo } from 'react';
import { View } from 'react-native';
import { CardView, rem } from 'design-system';
import { AppView } from 'design-system/AppView';
import EmptyComponent from 'design-system/EmptyComponent';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { SettingsItemNavigate } from 'design-system/SettingsItem';
import Spacer from 'design-system/Spacer';
import StatusBar from 'design-system/StatusBar';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { isWeb } from '../../../constants';
const strings = {
    title: 'Would you like to import transactions to this offline account?',
    subtitle: 'You can also skip for now and import them later',
    import: 'Yes, import transactions',
    skip: 'Skip for now',
};
const DummyAccountCreationImportScreen = ({ navigation, route }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
            ...(isWeb && {
                title: 'Logo Type',
                headerTitle: EmptyComponent,
            }),
        });
    }, [colors.text.primary]);
    const routeParams = useMemo(() => ({
        ...(route.params || {}),
        keyBack: route.params?.keyBack || route.key,
    }), [route.params, route.key]);
    const onImport = useCallback(() => {
        navigation.navigateDeprecated('DummyAccountImportTransactions', {
            ...routeParams,
        });
    }, [routeParams]);
    const onSkipImport = useCallback(() => {
        navigation.navigateDeprecated('AddBalance', {
            ...routeParams,
        });
    }, [routeParams]);
    return (<AppView type="secondary" paddingBottom isInTab={isWeb} avoidHeader>
      <View style={styles.container}>
        <StatusBar barStyle="dark-content" animated/>
        <ScreenInfoHeader title={strings.title} subTitle={strings.subtitle}/>
        <CardView noMarginTop>
          <SettingsItemNavigate title={strings.import} onPress={onImport} style={styles.containerPadding}/>
        </CardView>
        <CardView noMarginTop>
          <SettingsItemNavigate title={strings.skip} onPress={onSkipImport} style={styles.containerPadding}/>
        </CardView>
        <Spacer flex/>
      </View>
    </AppView>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        flex: 1,
    },
    centered: {
        alignSelf: 'center',
    },
    containerPadding: {
        ...(isWeb && {
            padding: rem(8),
        }),
    },
}));
export default DummyAccountCreationImportScreen;
